import { useState } from "react";
import { COOKIES } from "@/constants";
import { useCookie } from "./useCookie";
import type { SarasGlobalCookie, UserCookie } from "@/types/cookies";

export interface UserDetails {
  userId: string;
  email: string;
  name: string;
  role?: string;
  preferences?: Record<string, any>;
}

export interface UpdateUserDetailsRequest {
  name?: string;
  preferences?: Record<string, any>;
}

// @ts-ignore
const API_BASE_URL = "http://localhost:3000/";

export const useUser = () => {
  const [userState, setUserState] = useState<UserCookie | null>(null);
  const [userCookie, updateUserCookie, removeUserCache] =
    useCookie<UserCookie>(COOKIES.cacheKeysEnum.saras_user_details);
  const [sarasGlobal] = useCookie<SarasGlobalCookie>(COOKIES.saras_global, {
    sarasDomain: true,
  });

  const getUserDetails = () => {
    if (!userState && sarasGlobal?.userId && sarasGlobal.userId === userCookie?.userId) {
      setUserState(userCookie);
      return userCookie;
    }
    return userState;
  };
  const setUserDetails = (userDetails: UserCookie) => {
    updateUserCookie(userDetails);
    setUserState(userDetails);
  };
  const removeUserDetails = () => {
    removeUserCache();
    setUserState(null);
  };

  return {
    userDetails: userState,
    getUserDetails,
    setUserDetails,
    removeUserDetails,
  };
};
